module.exports = function() {
	return new Worker(__webpack_public_path__ + "scripts/worker-5504d6.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/webworker-loader?filename=scripts/worker-[hash:6].js!./src/service/teams/worker.js
// module id = 593
// module chunks = 0